import { GlobalWorkerOptions } from 'pdfjs-dist';

const baseUrl = process.env.BASE_URL || '/';
const normalizedBaseUrl = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
const PDFJS_WASM_URL = `${normalizedBaseUrl}pdfjs/wasm/`;

/*
 * @tato30/vue-pdf ma nowoczesny worker pdf.js wklejony w swój bundle jako data: URL i
 * ustawia go sobie sam przy załadowaniu modułu. Na Chromium 115 z vMiksa ten worker jest
 * nie do użycia (Promise.withResolvers - Chrome 119), więc podmieniamy go na build legacy
 * z polyfillami core-js. Przypisanie jest bezwarunkowe i czytane dopiero przy tworzeniu
 * workera, więc wygrywa niezależnie od kolejności importów - a ten helper i tak jest
 * ładowany razem z createPdfSource, zanim cokolwiek otworzy PDF.
 *
 * Plik w public/ to kopia node_modules/pdfjs-dist/legacy/build/pdf.worker.min.mjs (tak samo
 * jak wasm obok) - przy podbiciu pdfjs-dist trzeba ją odświeżyć. Rozjazd wersji pdf.js
 * zgłasza sam: "The API version does not match the Worker version". Rozszerzenie .js
 * zamiast .mjs, bo statyczne pliki hosta nie mają zmapowanego typu MIME dla .mjs.
 */
GlobalWorkerOptions.workerSrc = `${normalizedBaseUrl}pdfjs/pdf.worker.legacy.min.js`;

export function createPdfSource(data) {
    const source = data instanceof Uint8Array
        ? data
        : new Uint8Array(data);

    return {
        data: source,
        wasmUrl: PDFJS_WASM_URL,
    };
}
